<template>
  <div style="font-size: 16px">
    <div class="weui-mask_transparent"></div>
    <div class="toast_wrap">
      <span class="toast"><slot /></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    duration: {
      type: Number,
      default: 1500,
    },
  },
  mounted() {
    const that = this;
    const { duration } = this;
    this.timer = setTimeout(() => {
      that.close();
    }, duration);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    /**
     * 关闭
     */
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.toast_wrap {
  position: fixed;
  z-index: 5000;
  top: 45%;
  left: 0;
  right: 0;
  text-align: center;

  .toast {
    display: inline-block;
    background-color: hsla(0,0%,7%,.7);
    border-radius: .25rem;
    color: #fff;
    font-size: .7rem;
    padding: .3rem .6rem;
    max-width: 15rem;
  }
}
</style>
